export enum API_URL {
    HOST = "https://api.8am.vn",
    // HOST = "https://api-sing.8am.vn",
    GET_TOPICS_LIST = "https://crawler.deepaicare.com/api/topic",
};
export enum CONST {
    HOT_TOPIC_ID = "8320840b-e2fc-42fa-9614-3dd66083d795",
}